import {
  Avatar,
  Grid,
  Link,
  makeStyles,
  Toolbar,
  IconButton,
  Card,
  ListItem,
  List,
  ListItemIcon,
  Divider,
  InputLabel,
  Button,
  Box,
  Popover,
  Badge,
  Typography,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import React, { useState } from "react";
import {
  Search,
  Business,
  SupervisorAccount,
  AddCircleOutlined,
  ExpandMore,
} from "@material-ui/icons";
import MenuIcon from "@material-ui/icons/Menu";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../Images/logo.png";
import NotificationsNoneSharpIcon from "@material-ui/icons/NotificationsNoneSharp";
import NotificationDrawer from "../../../src/Pages/Roles/Admin/Notifications/NotificationDrawer";
import { Autocomplete } from "@material-ui/lab";
import DataService from "../../Service";
import DataClient from "../../Service/general_data_service";
import {
  DELETE_DATA,
  DELETE_STEPPER_DATA,
  GLOBAL_STEPPER_DATA,
} from "../../Redux/actions";
import { fetchNotification } from "../../../src/Pages/Roles/Admin/Notifications/store/notificationService";

import { ResetOrganisationDetails } from "../../Pages/Roles/Admin/Organisation/Create/OrganisationDetails/OrganisationDetailsActions";
import { ResetActivity } from "../../Pages/Roles/Admin/Organisation/Create/Activity/OrganisationActivityActions";
import { ResetContact } from "../../Pages/Roles/Admin/Organisation/Create/Contact/OrganisationContactActions";
import { ResetContract } from "../../Pages/Roles/Admin/Organisation/Create/Contract/OrganisationContractActions";
import { ResetGeneral } from "../../Pages/Roles/Admin/Organisation/Create/General/OrganisationGeneralActions";
import { ResetBusinessDevelopment } from "../../Pages/Roles/Admin/Organisation/Create/OrganisationBusinessDevelopment/OrganisationBusinessDevelopmentActions";
import { ResetPreContract } from "../../Pages/Roles/Admin/Organisation/Create/PreContract/OrganisationPreContractActions";
import { ResetProfile } from "../../Pages/Roles/Admin/Organisation/Create/Profile/OrganisationProfileActions";
import logoImage from "../../Images/acuity-coaching-simple-logo2.svg";
// import Image from 'material-ui-image'
import { useEffect } from "react";
import { queryClient } from "../..";

function AdminHome() {
  const [menu, setMenu] = useState("");
  const classes = useStyles();
  const [menuType, setMenuType] = useState("Organization");
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchResult, setSearchResult] = useState([]);
  const [manageAnchorEl, setManageAnchorEl] = useState(null);
  const [searchCatAnchorEl, setSearchCatAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const manageOpen = Boolean(manageAnchorEl);
  const searchCatOpen = Boolean(searchCatAnchorEl);
  const [userData, setUserData] = useState();
  const [value, setValue] = React.useState("");
  const [inputValue, setInputValue] = React.useState("");
  const [refreshNotification, setRefreshNotification] = useState(false);

  const [action, setAction] = useState<string>("");

  const history = useHistory();
  const dispatch = useDispatch();
  const globalUserData = useSelector((state: any) => state.commonReducer);
  let adminName = globalUserData?.userData?.name || "";

  let role = globalUserData?.role || "";

  const bgColor =
    role == "partner" || role == "employee"
      ? "linear-gradient(45deg, rgb(71, 0, 0) 30%, rgb(150, 0, 0) 90%)"
      : "rgb(48, 48, 48)";

  const notification = useSelector((state: any) => state.notifications);

  const handleChange = (event: any) => {
    // setAuth(event.target.checked);
  };

  const handleMenu = (event: any, type: any) => {
    type == "manage"
      ? setManageAnchorEl(event.currentTarget)
      : type == "searchCat"
      ? setSearchCatAnchorEl(event.currentTarget)
      : setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setManageAnchorEl(null);
    setSearchCatAnchorEl(null);
    setAnchorEl(null);
  };
  const logout = () => {
    queryClient.clear();
    sessionStorage.clear();
    sessionStorage.removeItem("authorization_headers");
    sessionStorage.removeItem("jobRole");
    dispatch({ type: DELETE_DATA });
  };

  const handleCloseNotificationDrawer = (event: any, newValue: any) => {
    setAction("");
  };

  const openSuggetion = (value: any) => {
    const menuTypeData = menuType === "Client program" ? "Program" : menuType;
    DataClient.getData(
      "home_pages/filter_by_categories?category=" +
        menuTypeData +
        "&search_keyword=" +
        value
    ).then((response: any) => {
      console.log(`response`, response);
      searchResult.length = 0;
      setSearchResult(
        searchResult.concat(response.data == null ? [] : response.data)
      );
    });
  };

  useEffect(() => {
    dispatch(fetchNotification());
  }, [refreshNotification]);

  return (
    <Grid direction="row" justify="center" alignItems="center">
      <Grid
        xs={12}
        justify="center"
        alignItems="center"
        style={{
          textAlign: "left",
          background: "#077F83",
          position: "relative",
        }}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          style={{ border: "0px solid red" }}
        >
          <Grid item xs={2}>
            {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                            <MenuIcon
                                style={{ color: 'white', position: 'fixed', top: 20, bottom: 0, left: 30, right: 10, }} />
                        </IconButton> */}
            <Box
              style={{
                width: "114px",
                marginLeft: 50,
                background: "white",
                borderRadius: "5px",
                height: "32px",
              }}
            >
              <img
                src={logoImage}
                alt="Acuity"
                className={classes.logoImg}
                onClick={() => {
                  history.push("/ManageInfo");
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={5}>
            <Grid
              container
              className={classes.orgSearchBox}
              direction="row"
              alignItems="center"
            >
              <div style={{ display: "contents" }}>
                <div>
                  <Button
                    disableFocusRipple
                    disableElevation
                    endIcon={<ExpandMore />}
                    style={{
                      color: "#fff",
                      textTransform: "none",
                      lineHeight: 1,
                      fontSize: "15px",
                    }}
                    onClick={(e: any) => {
                      menu == "organization"
                        ? setMenu("")
                        : setMenu("organization");
                      handleMenu(e, "searchCat");
                    }}
                  >
                    {menuType}
                  </Button>
                  {/* <Link onClick={(e: any) => {
                                        menu == 'organization' ? setMenu('') : setMenu('organization');
                                        handleMenu(e, 'searchCat');
                                    }}>
                                        <Typography className={classes.searchBoxTitle}>{menuType}</Typography>
                                        <ExpandMore />
                                    </Link> */}

                  <Popover
                    id={searchCatOpen ? "simple-popover" : undefined}
                    open={searchCatOpen}
                    anchorEl={searchCatAnchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    style={{ zIndex: 9999, top: 12 }}
                  >
                    <List
                      component="nav"
                      aria-label="main mailbox folders"
                      style={{ width: "fit-content" }}
                    >
                      {[
                        { name: "Organization", subTitle: "Search by name" },
                        { name: "Partner", subTitle: "Search by name" },
                        { name: "Employee", subTitle: "Search by name" },
                        { name: "Client program", subTitle: "Search by name" },
                        { name: "Assignment", subTitle: "Search by name" },
                      ].map((e: any) => (
                        <ListItem
                          className={
                            menuType == e.name
                              ? classes.active
                              : classes.inActive
                          }
                          onClick={() => {
                            setMenuType(e.name);
                            handleClose();
                          }}
                        >
                          <ListItemIcon style={{ minWidth: 0 }}>
                            <Business />
                          </ListItemIcon>
                          <Typography
                            variant="h2"
                            style={{
                              width: 100,
                              color: "#0000008a",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {e.name}
                          </Typography>
                          <Typography
                            variant="h2"
                            style={{ color: "#0000008a", whiteSpace: "nowrap" }}
                          >
                            {e.subTitle}
                          </Typography>
                        </ListItem>
                      ))}
                    </List>
                  </Popover>
                  {/* {menu === 'organization' && <Card className={classes.menuOption}>
                                      
                                        <Divider />

                                    </Card>} */}
                </div>
              </div>
              <div className={classes.searchBox}>
                <Autocomplete
                  id="free-solo-2-demo"
                  freeSolo
                  options={searchResult}
                  value={value}
                  getOptionLabel={(option: any) => option.value}
                  renderOption={(props: any, option: any) => (
                    <Typography variant="h2" color="initial" id={props.id}>
                      {props.value}
                    </Typography>
                  )}
                  onChange={(event: any, newValue: any) => {
                    var url: any = "";
                    console.log("newValue", newValue);
                    if (newValue) {
                      menuType == "Organization" &&
                        (url = "/admin/organisation/" + newValue.id);
                      if (menuType == "Partner") {
                        dispatch({
                          type: GLOBAL_STEPPER_DATA,
                          payload: { partner_profile: newValue.id },
                        });
                        url = "/admin/partner/onboarding";
                      }
                      menuType == "Employee" &&
                        (url =
                          "/admin/organisation/" +
                          newValue.organisation_id +
                          "/employee/" +
                          newValue.id +
                          "/edit");
                      menuType == "Client program" &&
                        (url = {
                          pathname:
                            "/admin/organisation/" + newValue.organisation_id,
                          state: { id: newValue.organisation_id },
                        });
                      menuType == "Assignment" &&
                        (url = {
                          pathname: "/assignmentoverview",
                          state: {
                            currentAssignment: {
                              id: newValue.id,
                              name: newValue.value,
                            },
                          },
                        });
                      history.push(url);
                    }
                  }}
                  style={{ width: "100%", zIndex: 9991, color: "#fff" }}
                  inputValue={inputValue}
                  onInputChange={(event: any, newInputValue: any) => {
                    setInputValue(newInputValue);
                    openSuggetion(newInputValue);
                  }}
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                        className: classes.searchInput,
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search className={classes.searchIcon} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </div>
            </Grid>
          </Grid>

          <Grid item xs={5} alignItems="center" justify="center">
            <Toolbar style={{ float: "right" }}>
              <Typography variant="h2">
                <Link
                  onClick={() => {
                    history.push("/ManageInfo");
                  }}
                  className={classes.menuTitle}
                >
                  Home
                </Link>
              </Typography>
              <Typography variant="h2">
                <Link
                  onClick={() => {
                    history.push("/admin/reports");
                  }}
                  className={classes.menuTitle}
                >
                  Reports
                </Link>
              </Typography>
              <Typography variant="h2">
                <Link
                  onClick={() => {
                    history.push("/admin/setup");
                  }}
                  className={classes.menuTitle}
                >
                  Setup
                </Link>
              </Typography>
              <Typography variant="h2">
                <Link
                  className={classes.menuTitle}
                  onClick={(e: any) => {
                    menu == "manage" ? setMenu("") : setMenu("manage");
                    handleMenu(e, "manage");
                  }}
                >
                  Manage
                </Link>
                <Popover
                  id={manageOpen ? "simple-popover" : undefined}
                  open={manageOpen}
                  anchorEl={manageAnchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  style={{ zIndex: 9999, top: 15 }}
                >
                  <List component="nav" aria-label="main mailbox folders">
                    {[
                      {
                        name: "Organization",
                        route: "/admin/organisation/create",
                        listRoute: "/admin/organisation/list",
                      },
                      {
                        name: "Partners",
                        route: "/admin/partner/onboarding",
                        listRoute: "/admin/partner/list",
                        routeState: {
                          type: "create",
                        },
                      },
                      {
                        name: "CRF's",
                        route: "/admin/crf",
                        listRoute: "/admin/crf",
                      },
                    ].map((e: any) => (
                      <ListItem
                        style={
                          e.name === "CRF's"
                            ? { paddingTop: "16px" }
                            : { paddingTop: "8px" }
                        }
                      >
                        <ListItemIcon style={{ minWidth: 0 }}>
                          <SupervisorAccount />
                        </ListItemIcon>
                        <Link
                          onClick={() => {
                            dispatch({ type: DELETE_STEPPER_DATA });
                            dispatch(ResetOrganisationDetails());
                            dispatch(ResetActivity());
                            dispatch(ResetBusinessDevelopment());
                            dispatch(ResetContact());
                            dispatch(ResetContract());
                            dispatch(ResetGeneral());
                            dispatch(ResetPreContract());
                            dispatch(ResetProfile());
                            history.push(e.listRoute);
                          }}
                        >
                          <Typography
                            variant="h2"
                            style={{
                              marginLeft: 20,
                              minWidth: 120,
                              color: "#0000008a",
                              fontWeight: "bold",
                            }}
                          >
                            {e.name}
                          </Typography>
                        </Link>

                        {e.name !== "CRF's" && (
                          <Button
                            disableElevation
                            variant="contained"
                            color="secondary"
                            style={{ textTransform: "none" }}
                            onClick={() => {
                              // dispatch(ResetOrganisationDetails());
                              // dispatch(ResetActivity());
                              // dispatch(ResetBusinessDevelopment());
                              // dispatch(ResetContact());
                              // dispatch(ResetContract());
                              // dispatch(ResetGeneral());
                              // dispatch(ResetPreContract());
                              // dispatch(ResetProfile());
                              history.push(e.route, e.routeState || {});
                              window.location.reload();
                            }}
                          >
                            <AddCircleOutlined
                              style={{ marginRight: 10, fontSize: 15 }}
                            />
                            Create
                          </Button>
                        )}
                      </ListItem>
                    ))}
                  </List>
                  <Divider />
                </Popover>
              </Typography>
              <Typography variant="h2">
                <Link
                  onClick={() => history.push("/admin/dashboard")}
                  className={classes.menuTitle}
                >
                  Dashboard
                </Link>
              </Typography>
              <Typography variant="h2">
                <Badge
                  badgeContent={notification?.notification?.unread_notification_count?.toString()}
                  color="secondary"
                  onClick={() => {
                    setAction("notification");
                  }}
                >
                  <NotificationsNoneSharpIcon
                    className={classes.notifications}
                  />
                </Badge>
              </Typography>
              <Typography variant="h2">
                <Box
                  display="flex"
                  alignItems="center"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    menu === "user" ? setMenu("") : setMenu("user");
                    handleMenu(e, "user");
                  }}
                >
                  <Link className={classes.menuTitle}>{adminName}</Link>

                  <Link
                    style={{ marginLeft: 20, color: "white", marginTop: 5 }}
                  >
                    <ExpandMore />
                  </Link>
                </Box>
                <Popover
                  id={open ? "simple-popover" : undefined}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  style={{ zIndex: 9999, top: 12 }}
                >
                  <List
                    component="nav"
                    aria-label="main mailbox folders"
                    style={{ padding: "8px 16px 8px 8px" }}
                  >
                    {[
                      {
                        name: "Profile",
                        route: "/",
                        listRoute: "/admin/partner/onboarding",
                        routeState: {
                          type: "create",
                        },
                      },
                      // { name: "Settings" },
                      {
                        name: "Sign out",
                        route: "/",
                        listRoute: "/",
                        logout: "yes",
                      },
                    ].map((e: any) => (
                      <Link
                        onClick={() => {
                          history.push(e.listRoute, e.routeState || {});
                          e.logout === "yes" && logout();
                        }}
                      >
                        <ListItem>
                          <Typography variant="h2">{e.name}</Typography>
                        </ListItem>
                      </Link>
                    ))}
                  </List>
                </Popover>
                <Divider />
              </Typography>
              <Avatar
                style={{ marginTop: 2 }}
                alt=""
                src="/static/images/avatar/1.jpg"
              />
            </Toolbar>
          </Grid>
        </Grid>
      </Grid>
      {action && action == "notification" && (
        <NotificationDrawer
          action={action}
          handleClose={handleCloseNotificationDrawer}
          notificationList={notification?.notification}
          setRefreshNotification={setRefreshNotification}
        />
      )}
    </Grid>
  );
}

export default AdminHome;

const useStyles = makeStyles((theme) => ({
  active: {
    borderLeft: "3px solid #3b86ff",
    backgroundColor: "#f4f4f4",
    gap: "14px",
  },
  inActive: {
    borderLeft: "3px solid #fff",
    gap: "14px",
  },
  logoImg: {
    width: 111,
    marginTop: 8,
    marginLeft: 1,
    //  borderRadius: 5,
    cursor: "pointer",
  },
  menuOption: {
    border: "0px solid red",
    position: "absolute",
    zIndex: 1,
    // maxWidth: 360,
    // minWidth: 330,
    top: 52,
  },
  searchBar: {
    border: "2px solid red",
    color: "#fff",
  },
  orgSearchBox: {
    flexWrap: "nowrap",
    backgroundColor: "#077F83",
    border: "1px solid #fff",
    height: 40,
    borderRadius: 5,
    color: "white",
  },

  searchBox: {
    borderLeft: "1px solid #fff",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 1,
    marginLeft: 10,
    width: "calc(100% - 140px)",
  },
  searchInput: {
    color: "#fff",
    "& .MuiAutocomplete-endAdornment svg": {
      color: "#fff",
    },
  },
  inputBox: {
    backgroundColor: "transparent",
    borderWidth: "0px",
    color: "white",
    border: "1px solid red",
    height: "30px",
    width: "250px",
    marginLeft: 20,
  },
  searchIcon: {
    marginLeft: "12px",
    marginRight: "3px",
    color: "#fff",
    fontSize: 18,
  },

  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  title: {
    flexGrow: 2,
  },
  menuTitle: {
    marginLeft: 20,
    color: "#fff",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "none",
    },
  },
  notifications: {
    marginLeft: 15,
    color: "#fff",
    cursor: "pointer",
    width: "20px",
    height: "25px",
    "&:hover": {
      textDecoration: "none",
    },
    "& .MuiBadge-badge": {
      background: "rgb(239, 112, 0)",
    },
  },
}));
